MOBILE_WIDTH_TRESHOLD = 750;
MENU_MOBILE_WIDTH_TRESHOLD = 900;
$(document).ready(function() {

    $('.read-more-btn').on('click', function () {
        console.log('clicked');
        const $btn = $(this);
        const $text = $btn.siblings('.offering-text');

        $text.toggleClass('expanded');

        $btn.text(
            $text.hasClass('expanded') ? 'Read less' : 'Read more'
        );
    });

    $('.testimonials-block > .gliders').not('.slick-initialized').slick({
        arrows: false,
        dots: false,
        infinite: true,
        autoplay: true,
        speed: 900,
        autoplaySpeed: 6000,
        pauseOnHover: false,
        pauseOnFocus: false,
        adaptiveHeight: false,
    });

    $('.open-menu-burger-item-children').click(function() {
        var _id = $(this).data('id');
        if($(this).hasClass('opened'))
        {
            $('#menu-burger-item-children-' + _id).slideUp();
            $(this).removeClass('opened');
            $(this).html('<i class="fa-solid fa-chevron-down"></i>');
        }
        else
        {
            $('#menu-burger-item-children-' + _id).slideDown();
            $(this).addClass('opened');
            $(this).html('<i class="fa-solid fa-times"></i>');
        }
    });

    $('.menu-btn').click(function() {
        $('.main-nav').addClass('active');
        $('#menu-main-menu').addClass('active');
    });

    $('.close-menu').click(function() {
        $('.main-nav').removeClass('active');
        $('#menu-main-menu').removeClass('active');
    });

    $('.menu-item-has-children').click(function() {
        $(this).children('.dropdown').toggleClass('active');
        $(this).children('.sub-menu').toggleClass('active');
        $(this).toggleClass('active');
    });

    $('.filter-head').click(function() {
        $(this).toggleClass('active');
        $('.search-bar').toggleClass('active');
        $('.category-filters').toggleClass('active');
    });

    $(window).bind('hashchange', function() {
        var hash = document.location.hash;
        var hash = hash.replace('#', '');

    });
    window.onload = function() {
        var hash = (window.location.hash).replace('#', '');

    }
    if (location.href.indexOf("#") != -1) {
            var hash = window.location.hash.substring(1);
            var hash = hash.replace('#', '');

    }

    if (typeof window.location.search.substr(1) != "undefined") {
        if (window.location.search.substr(1) === "book-a-table") {
            $('#table-book-old').addClass('active');
        }
    }

    $('.close-iframe').click(function() {
        $('.table-book-wrap').removeClass('active');
    });

    $('.close-popup').click(function() {
        $('.popup-wrap').removeClass('enable-popup');
    });

    let lastScrollTop = 0;
    let scrollTop = 0;
    if(!$('body').hasClass('prestige'))
    {
        let SCROLL_THRESHOLD = 10;
        $(window).scroll(function ()
        {
            scrollTop = $(window).scrollTop();

            if (scrollTop >= SCROLL_THRESHOLD) {
                if(!$('.page-head').hasClass('scrolled-nav')){
                    $('.page-head').addClass('scrolled-nav');
                }
            }
            else {
                $('.page-head').removeClass('scrolled-nav');
            }

            lastScrollTop = scrollTop;
        });
    }
    else
    {
        let SCROLL_THRESHOLD = 10;
        $(window).scroll(function ()
        {
            scrollTop = $(window).scrollTop();

            if (scrollTop >= SCROLL_THRESHOLD) {
                if(!$('.page-head').hasClass('scrolled-nav')){
                    $('.page-head').addClass('scrolled-nav');
                }
            }
            else {
                $('.page-head').removeClass('scrolled-nav');
            }

            lastScrollTop = scrollTop;
            reveal();
        });
        scrollTop = $(window).scrollTop();

        if (scrollTop >= SCROLL_THRESHOLD) {
            $('.page-head').addClass('scrolled-nav');
        }

        $('.flexible-content-wrap-premium.prestige').children().eq(1).find('.reveal').each((k,v) =>{
            $(v).removeClass('reveal');
        });
        $('.flexible-content-wrap-premium.prestige').children().eq(1).find('.reveal-no-fade').each((k,v) =>{
            $(v).removeClass('reveal-no-fade');
        });

        lastScrollTop = scrollTop;
        reveal();
    }

    $('.hero-book').click(function() {
        $('.hero-popup').addClass('active');
    });

    $('.form-close').click(function() {
        $('.hero-popup').removeClass('active');
    });

    if($('body').hasClass('premium')) {
        if(!$('body').hasClass('prestige')) {
            checkTop();
        }

        $('.faqs .list-element').click(function(e){
            $(this).toggleClass('open');
        });

        $('.book-bar input[type="text"]').each(function(k,v){
            $(v).datepicker({ dateFormat: 'dd/mm/yy' });
        });

        if($('.book-bar form').length){

            $('.book-bar form').each(function(){
                $(this).submit(function(e){

                    if($(this).find('input[name="dateFrom"]').val() && $(this).find('input[name="dateTo"]').val()){

                        var arrival = convertUKDateStringToUSDateString($(this).find('input[name="dateFrom"]').val())
                        var departure = convertUKDateStringToUSDateString($(this).find('input[name="dateTo"]').val())
                        var date1 = new Date(arrival);
                        var date2 = new Date(departure);

                        // To calculate the time difference of two dates
                        var Difference_In_Time = date2.getTime() - date1.getTime();

                        // To calculate the no. of days between two dates
                        var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

                        $(this).find('input[name="numNights"]').val(Difference_In_Days);

                    } else {
                        $(this).append('<div class="alert alert--error">Please enter dates in the format dd/mm/yyyy</div>');
                        e.preventDefault();
                    }
                });
            });
        }

        if($('.vimeo').length > 0){
            checkVimeo();
        }
    }

    $('button[name="add-to-cart"]').on('click', function(){
        fbq('track', 'AddToCart');
    });

    $('a.checkout-button').on('click', function(){
        fbq('track', 'InitiateCheckout');
    });

    $('.mobile-carousel').each((k, v) => {
        $(v).slick({
            arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            cssEase: 'linear',
            speed: 2000,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            pauseOnFocus: false,
            adaptiveHeight: false,
            fade: true
        });
    });

    /** JS for Generic Pager - Start **/
    $('.pager-container > .pager-select').change(function() {
        var _slug = $(this).data('slug');
        var _page = $(this).val();
        location.href = '/' + _slug + '/page/' + _page;
    });

    $('.pager-container > .pager-start').click(function() {
        if($(this).hasClass('pager-disabled'))
            return false;

        var _slug = $('.pager-container > .pager-select').data('slug');
        location.href = '/' + _slug ;
    });

    $('.pager-container > .pager-prev').click(function() {
        if($(this).hasClass('pager-disabled'))
            return false;

        var _slug = $('.pager-container > .pager-select').data('slug');
        var _page = $('.pager-container > .pager-select').val();
        _page--;
        location.href = '/' + _slug + '/page/' + _page;
    });

    $('.pager-container > .pager-next').click(function() {
        if($(this).hasClass('pager-disabled'))
            return false;

        var _slug = $('.pager-container > .pager-select').data('slug');
        var _page = $('.pager-container > .pager-select').val();
        _page++;
        location.href = '/' + _slug + '/page/' + _page;
    });

    $('.pager-container > .pager-end').click(function() {
        if($(this).hasClass('pager-disabled'))
            return false;

        var _slug = $('.pager-container > .pager-select').data('slug');
        var _page = $('.pager-container > .pager-select').data('maxpage');
        location.href = '/' + _slug + '/page/' + _page;
    });
    /** JS for Generic Pager - End **/

    //**JS for stats column count **/

    const headings = document.querySelectorAll('.three-column-stats-block-flexbox .heading');

    const parseValue = (text) => {
        const match = text.match(/^([^0-9]*)(\d+)([^0-9]*)$/);
        if (!match) return null;

        return {
            prefix: match[1] || '',
            number: parseInt(match[2], 10),
            suffix: match[3] || ''
        };
    };

    const animate = (el, data) => {
        let current = 0;
        const duration = 1200;
        const step = Math.max(Math.floor(duration / data.number), 20);

        const timer = setInterval(() => {
            current++;
            el.textContent = `${data.prefix}${current}${data.suffix}`;

            if (current >= data.number) {
                el.textContent = `${data.prefix}${data.number}${data.suffix}`;
                clearInterval(timer);
            }
        }, step);
    };

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (!entry.isIntersecting || entry.target.dataset.counted) return;

            const data = parseValue(entry.target.textContent.trim());
            if (!data) return;

            entry.target.dataset.counted = 'true';
            entry.target.textContent = `${data.prefix}0${data.suffix}`;

            animate(entry.target, data);
        });
    }, { threshold: 0.5 });

    headings.forEach(h => observer.observe(h));

    //**JS for stats column count - End **/

    initBlogFilterEvents();
    customEventHandlers();
});

function customEventHandlers(){
    if(window.innerWidth < MENU_MOBILE_WIDTH_TRESHOLD)
    {
        $('.menu-item-level-1').each(function(){
            $(this).addClass('mobile_menu_trigger');
        });

        $('.menu-item-level-1 > a.menu-item-has-children').each(function(){
            $(this).attr('href', 'javascript:void(0);');
        });

        $('.menu-item-level-1 > a.menu-item-has-children').click(function(){
            $('.menu-item-level-1').each(function(){
                $(this).addClass('hide-menu-item');
            });
            $('#column-right-content').addClass('hide-menu-item');
            $(this).parent('li').addClass('mobile_active');
        });

        $('.menu-item-level-back-btn > a').click(function(){
            $('.menu-item-level-1').each(function(){
                $(this).removeClass('hide-menu-item');
                $(this).removeClass('mobile_active');
            });
            $('#column-right-content').removeClass('hide-menu-item');
        });
    }

    /** Menu Overlay - click anywhere to close - start **/
    $('.page-modal').on('click', function(e){
        // console.log(e.pageX + ' , ' + e.pageY);
        // if(e.pageX > 400){
            hideMenu();
        // }
    });
    /** Menu Overlay - click anywhere to close - end **/

    /** JS for Two Column CTA Slider Block - start */
    const slides = $('.two-column-cta-slider-block > .section__shell > .section__content');
    $(slides).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        prevArrow: ".slider-prev-tccsb",
        nextArrow: ".slider-next-tccsb",
        infinite: true,
        centerMode: true,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    dots: true,
                    arrows: false
                }
            }
        ]
    });
    /** JS for Two Column CTA Slider Block - end */

    /** JS for ( Es ) - Single Column Full Image + CTA Block (Slider) - start */
    const slides2 = $('.single-column-full-image-cta-block-slider > .section__shell > .section__slides');
    $(slides2).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        autoplay: true,
        cssEase: 'linear',
        autoplaySpeed: 5000,
        infinite: true
    });
    /** JS for ( Es ) - Single Column Full Image + CTA Block (Slider) - end */

    /** JS for ( A ) - Hero Block - start */
    const slides3 = $('.hero-block-wrapper > .image-wrapper > .image-carousel');
    $(slides3).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        autoplay: true,
        cssEase: 'linear',
        autoplaySpeed: 5000,
        infinite: true
    });
    /** JS for ( A ) - Hero Block - end */

    /** JS for Tiny Image+Text Cards Slider Block - start */
    const slides4 = $('.tiny-image-text-cards-slider-block > .section__shell > .section__content');
    $(slides4).slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        prevArrow: ".slider-prev-titcsb",
        nextArrow: ".slider-next-titcsb",
        infinite: true,
        centerMode: true,
        focusOnSelect: false,
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false
                }
            }
        ]
    });
    /** JS for Tiny Image+Text Cards Slider Block - end */

    /** JS for Company Logo Ads Slider Block - start */
    const slides5 = $('.company-logo-ads-slider-block > .section__shell > .section__content');
    $(slides5).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        infinite: true,
        centerMode: true,
        focusOnSelect: false,
        autoplay: true,
        autoplaySpeed: 5000,
    });
    /** JS for Company Logo Ads Slider Block - end */

    /** JS for News Banner Slider Block - start */
    const slides6 = $('.news-banner-slider-block > .section__shell > .section__content');
    slides6 .append(slides6 .html());
    $(slides6).slick({
        speed: 12000,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        arrows: false,
        buttons: false,
        pauseOnHover: true,
    });
    /** JS for News Banner Slider Block - end */

    /** JS for Image Slider Block - start */
    const slides7 = $('.image-slider-block > .section__shell > .section__content');

    $(slides7).slick({
        speed: 12000,
        autoplay: true,
        autoplaySpeed: 100,
        centerMode: true,
        cssEase: 'linear',
        slidesToShow: 10,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        initialSlide: 1,
        arrows: false,
        buttons: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: { slidesToShow: 6 }
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 4 }
            },
            {
                breakpoint: 480,
                settings: { slidesToShow: 2 }
            }
        ]
    });
    /** JS for Image Slider Block - end */

    $('.search-btn').off('click');
    $('.search-btn').on('click', function() {
        var _block_id = $(this).data('id');
        execPostTypeFilterBlockSearch(_block_id, this);
    });

    $('.search-field').off('keyup');
    $('.search-field').on('keyup', function(e) {
        if(e.which == 13){
            var _block_id = $(this).data('id');
            execPostTypeFilterBlockSearch(_block_id, this);
        }
    });

    $('.search-filter-checkbox').off('click');
    $('.search-filter-checkbox').on('click', function(e) {
        var _block_id = $(this).data('id');
        execPostTypeFilterBlockSearch(_block_id, this);
    });

    $('.post-type-checkbox-label').off('click');
    $('.post-type-checkbox-label').on('click', function(e) {
        $(this).prev('.search-filter-checkbox').click();
    });

    $('.search-filter-dropdown').off('change');
    $('.search-filter-dropdown').on('change', function(e) {
        var _block_id = $(this).data('id');
        execPostTypeFilterBlockSearch(_block_id, this);
    });

    $('.accordion-block-heading-trigger').off('click');
    $('.accordion-block-heading-trigger').on('click', function() {
        var _heading_trigger = $(this);

        if(_heading_trigger.hasClass('active')){
            _heading_trigger.removeClass('active');
            _heading_trigger.next().slideUp();
        }
        else{
            _heading_trigger.addClass('active');
            _heading_trigger.next().slideDown();
        }
    });

    /** script to align heading, excerpt content in blocks **/
    blocksSameHeight();

    /** for mobile devices only - start **/
    if(window.innerWidth < MOBILE_WIDTH_TRESHOLD) {
        $('.three-column-content-block > .section__shell > .section__content > .three-column-content-block-flexbox').slick({
            arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            cssEase: 'linear',
            autoplaySpeed: 5000,
            pauseOnHover: false,
            pauseOnFocus: false,
            adaptiveHeight: false
        });

        $('.three-column-page-link-block > .section__shell > .section__content > .three-column-page-link-block-flexbox').slick({
            arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            cssEase: 'linear',
            autoplaySpeed: 5000,
            pauseOnHover: false,
            pauseOnFocus: false,
            adaptiveHeight: false
        });

        $('.page-link-cards-block > .section__shell > .section__content > .page-link-cards-block-flexbox').slick({
            arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            cssEase: 'linear',
            autoplaySpeed: 5000,
            pauseOnHover: false,
            pauseOnFocus: false,
            adaptiveHeight: false
        });
    }
    /** for mobile devices only - end **/

    /** viewpport checker for animation when element become visible in the screen - start **/
    $('.viewport-animate-fade-up').viewportChecker({
        // Class to add to the elements when they are visible
        classToAdd: 'animate-fade-up',

        // The offset of the elements (let them appear earlier or later)
        offset: 100,

        // Add the possibility to remove the class if the elements are not visible
        repeat: false,

        // Callback to do after a class was added to an element. Action will return "add" or "remove", depending if the class was added or removed
        callbackFunction: function(elem, action){}
    });

    /** for image map hotspot plugin **/
    $('.imh-6310-template-01-hover-content').each(function(){
        $(this).html($(this).text());
    });

    /** validate gform using javascript - start **/
    _gform_validated = true;
    jQuery('.ginput_container_phone > input').on('blur', function(){
        // jQuery('.gform_validation_errors').each(function(){
        //     jQuery(this).remove();
        // });

        _gform_validated = true;
        var _field_container_id = jQuery(this).parent().parent().attr('id');
        var _message_id =  _field_container_id.replace('field_', 'validation_message_');

        var _phone_value = jQuery(this).val();
        _phone_value = _phone_value.replace(/ /g, '');
        _phone_value = _phone_value.replace(/\-/g, '');
        _phone_value = _phone_value.replace(/\(/g, '');
        _phone_value = _phone_value.replace(/\)/g, '');
        if(_phone_value.length < 10){
            _gform_validated = false;
            jQuery('#' + _message_id).remove();
            jQuery('#' + _field_container_id).append('<div id="' + _message_id + '" class="gfield_description validation_message gfield_validation_message">Phone Number is not Valid.</div>');
        }
        else{
            jQuery('#' + _message_id).remove();
        }
    });

    jQuery('.ginput_container_email > input, .ginput_container_text > input, .ginput_container_textarea > textarea').on('blur', function(){
        var _is_required = jQuery(this).attr('aria-required');

        if(_is_required == "true"){
            _gform_validated = checkGformRequiredFields(this);
        }
    });

    jQuery('#gform_1, #gform_2, #gform_3, #gform_4, #gform_5, #gform_6').on('submit', function(){
        var _gform = this;

        if(_gform_validated)
        {
            jQuery(_gform).find('.ginput_container_text > input').each(function(){
                var _is_required = jQuery(this).attr('aria-required');

                if(_is_required == "true"){
                    _gform_validated = checkGformRequiredFields(this);
                }
            });

            jQuery(_gform).find('.ginput_container_email > input').each(function(){
                var _is_required = jQuery(this).attr('aria-required');

                if(_is_required == "true"){
                    _gform_validated = checkGformRequiredFields(this);
                }
            });

            jQuery(_gform).find('.ginput_container_textarea > textarea').each(function(){
                var _is_required = jQuery(this).attr('aria-required');

                if(_is_required == "true"){
                    _gform_validated = checkGformRequiredFields(this);
                }
            });
        }

        setTimeout(function(){
            jQuery('.gform_ajax_spinner').each(function(){
                jQuery(this).remove();
            });
        }, 800);

        if(_gform_validated)
        {
            $('#page_modal_screen').show();
            setTimeout(function(){
                //-- remove modal maximum 20 seconds this could mean the form did not submit
                $('#page_modal_screen').hide();
            }, 20000);
        }
        // return _gform_validated;
    });
    /** validate gform using javascript - end **/

    $('.custom-anchor-tag').unbind('click');
    $('.custom-anchor-tag').click(function() {
        var _href = $(this).data('href');
        if(_href != '' && _href != undefined){
            location.href = _href;
        }
        return false;
    });

    if(window.location.toString().indexOf('#scroll--') > 0)
    {
        var _scroll_to = window.location.toString().split('#scroll--')[1];
        $('html, body').animate({
            scrollTop: $('#' + _scroll_to).offset().top - 120
        }, 800);
    }

    //-- prevent mousewheel when page-modal is opened
    var elem = document.getElementById ("page-modal");
    if (elem.addEventListener) {
        elem.addEventListener ("mousewheel", stopWheel, false);
        elem.addEventListener ("DOMMouseScroll", stopWheel, false);
    }
    else {
        if (elem.attachEvent) {
            elem.attachEvent ("onmousewheel", stopWheel);
        }
    }

    var elem2 = document.getElementById ("menu-overlay");
    if (elem2.addEventListener) {
        elem2.addEventListener ("mousewheel", stopWheel, false);
        elem2.addEventListener ("DOMMouseScroll", stopWheel, false);
    }
    else {
        if (elem2.attachEvent) {
            elem2.attachEvent ("onmousewheel", stopWheel);
        }
    }

}

function stopWheel(e){
    if(!e){ /* IE7, IE8, Chrome, Safari */
        e = window.event;
    }
    if(e.preventDefault) { /* Chrome, Safari, Firefox */
        e.preventDefault();
    }
    e.returnValue = false; /* IE7, IE8 */
}

function checkGformRequiredFields(_this){
    var _validated = true;
    var _field_container_id = jQuery(_this).parent().parent().attr('id');
    var _message_id =  _field_container_id.replace('field_', 'validation_message_');

    var _value = jQuery(_this).val();
    _value = _value.replace(/ /g, '');
    if(_value.length == 0)
    {
        _validated = false;

        // jQuery('.gform_validation_errors').each(function(){
        //     jQuery(_this).remove();
        // });

        // jQuery('#' + _field_container_id).parent().parent().parent().parent().prepend('<div class="gform_validation_errors" data-js="gform-focus-validation-error" tabindex="-1"><h3 class="gform_submission_error hide_summary">There was a problem with your submission. Please review the fields below.</h3></div>');
        jQuery('#' + _field_container_id).parent().parent().parent().find('.gform_button').attr('disabled', true);
        jQuery('#' + _field_container_id).parent().parent().parent().find('.gform_button').addClass('disabled');
        jQuery('#' + _message_id).remove();
        jQuery('#' + _field_container_id).append('<div id="' + _message_id + '" class="gfield_description validation_message gfield_validation_message">This field is required.</div>');
    }
    else
    {
        jQuery('#' + _message_id).remove();

        if(jQuery('#' + _field_container_id).parent().parent().parent().find('.gfield_validation_message').length == 0)
        {
            jQuery('#' + _field_container_id).parent().parent().parent().find('.gform_button').attr('disabled', false);
            jQuery('#' + _field_container_id).parent().parent().parent().find('.gform_button').removeClass('disabled');

            // jQuery('.gform_validation_errors').each(function(){
            //     jQuery(_this).remove();
            // });
        }
    }

    return _validated;
}

function execPostTypeFilterBlockSearch(_block_id, _this){
    _filters_array= [];

    if($('#search-field-' + _block_id).val() != ""){
        _filters_array.push('search=' + $('#search-field-' + _block_id).val());
    }

    var _selected_categories = [];
    if($('.search-filter-category-' + _block_id).hasClass('search-filter-dropdown')){
        _selected_categories.push($(_this).val());
    }
    else{
        $('.search-filter-category-' + _block_id).each(function(){
            if($(this).hasClass('search-filter-checkbox')){
                if($(this).is(':checked')){
                    _selected_categories.push($(this).val());
                }
            }
        });
    }

    if($(_this).hasClass('search-filter-event-date-type')){
        _filters_array.push('event-date-type=' + $(_this).val());
    }

    if(_selected_categories.length > 0){
        _filters_array.push('cat=' + _selected_categories.join(','));
    }

    _filters_array.push('validate=' + _block_id);

    var _page_slug = "";
    if($('.search-post-type-page-slug').length > 0){
        $('.search-post-type-page-slug').each(function(){
            _page_slug = $(this).val();
        });
    }

    var _filters = "";
    if(_filters_array.length > 0)
        _filters = "?" + _filters_array.join("&");

    var _href = '/' + _page_slug + _filters;
    if(_block_id != 'block-0'){
        _href += '#scroll--' + _block_id;
    }

    location.href = _href;
}

$(window).resize(function(){
    blocksSameHeight();
});

(function() {
    window.dispatchEvent(new Event('resize'));
})();

function blocksSameHeight(){
    if(window.innerWidth > MOBILE_WIDTH_TRESHOLD)
    {
        /** script to align heading, excerpt content in blocks - start **/
        var _block_names = [];
        _block_names.push('three-column-image-text-table-block');
        _block_names.push('three-column-content-block');
        _block_names.push('three-column-page-link-block');
        _block_names.push('page-link-cards-block');
        _block_names.push('tiles');
        _block_names.push('news-banner-slider-block');

        $.each(_block_names, function( index, value ) {
            $('.' + value).each(function(){
                var _height_heading = 40;
                var _height_excerpt = 120;
                var _this = this;
                var cardwrapper = $(_this).find('.card-wrapper');
                if(cardwrapper.length){
                    cardwrapper.find('.subheading').sameHeight();
                    cardwrapper.find('.heading').sameHeight();
                    cardwrapper.find('.content-wrapper').sameHeight();
                    cardwrapper.find('.content').sameHeight();
                    cardwrapper.find('.same-height-wrapper').sameHeight();
                }
            });
        });

        _block_names = [];
        _block_names.push('post-type-filter-block');
        $.each(_block_names, function( index, value ) {
            $('.' + value).each(function(){
                var _height_heading = 40;
                var _height_excerpt = 120;
                var _this = this;
                var cardwrapper = $(_this).find('.card-wrapper');
                if(cardwrapper.length){
                    cardwrapper.find('.content-wrapper').sameHeight();
                }
            });
        });

        _block_names = [];
        _block_names.push('post-type-filter-block');
        $.each(_block_names, function( index, value ) {
            $('.' + value).each(function(){
                var _height_heading = 40;
                var _height_excerpt = 120;
                var _this = this;
                var cardwrapper = $(_this).find('.section__inner');
                if(cardwrapper.length){
                    cardwrapper.find('.same-height-wrapper').sameHeight();
                    cardwrapper.find('.same-height-heading').sameHeight();
                    cardwrapper.find('.same-height-content').sameHeight();
                }
            });
        });

        _block_names = [];
        _block_names.push('tiny-image-text-cards-slider-block');
        $.each(_block_names, function( index, value ) {
            $('.' + value).each(function(){
                var _height_heading = 40;
                var _height_excerpt = 120;
                var _this = this;
                var cardwrapper = $(_this).find('.slick-track');
                if(cardwrapper.length){
                    cardwrapper.find('.heading').sameHeight();
                    cardwrapper.find('.single-slide').sameHeight();
                }
            });
        });
    }
}

function initBlogFilterEvents(){
    /** JS for Blog Pager - Start **/
    $('.pager-container > .pager-select').unbind('change');
    $('.pager-container > .pager-select').change(function() {
        var _slug = $(this).data('slug');
        var _page = $(this).val();
        location.href = '/' + _slug + '/page/' + _page + getBlogFiltersParams();
    });

    $('.pager-container > .pager-start').unbind('change');
    $('.pager-container > .pager-start').click(function() {
        if($(this).hasClass('pager-disabled'))
            return false;

        var _slug = $('.pager-container > .pager-select').data('slug');
        location.href = '/' + _slug  + getBlogFiltersParams();
    });

    $('.pager-container > .pager-prev').unbind('change');
    $('.pager-container > .pager-prev').click(function() {
        if($(this).hasClass('pager-disabled'))
            return false;

        var _slug = $('.pager-container > .pager-select').data('slug');
        var _page = $('.pager-container > .pager-select').val();
        _page--;
        location.href = '/' + _slug + '/page/' + _page + getBlogFiltersParams();
    });

    $('.pager-container > .pager-next').unbind('change');
    $('.pager-container > .pager-next').click(function() {
        if($(this).hasClass('pager-disabled'))
            return false;

        var _slug = $('.pager-container > .pager-select').data('slug');
        var _page = $('.pager-container > .pager-select').val();
        _page++;
        location.href = '/' + _slug + '/page/' + _page + getBlogFiltersParams();
    });

    $('.pager-container > .pager-end').unbind('change');
    $('.pager-container > .pager-end').click(function() {
        if($(this).hasClass('pager-disabled'))
            return false;

        var _slug = $('.pager-container > .pager-select').data('slug');
        var _page = $('.pager-container > .pager-select').data('maxpage');
        location.href = '/' + _slug + '/page/' + _page + getBlogFiltersParams();
    });
    /** JS for Blog Pager - End **/

    $('#filter_search').unbind('keyup');
    $('#filter_search').keyup(function(e){
        if(e.which == 13){
            var _slug = $('.pager-container > .pager-select').data('slug');
            var _page = $('.pager-container > .pager-select').val();

            location.href = '/' + _slug + '/page/' + _page + getBlogFiltersParams();
        }
    });

    $('.blog_filter_button').unbind('click');
    $('.blog_filter_button').click(function(){
        var _slug = $('.pager-container > .pager-select').data('slug');
        var _page = $('.pager-container > .pager-select').val();

        location.href = '/' + _slug + '/page/' + _page + getBlogFiltersParams();
    });

    $('.filter_box_toggle').unbind('click');
    $('.filter_box_toggle').click(function(){
        if($(this).hasClass('fa-caret-up')){
            $('.filter_box_toggle').each(function(){
                $(this).replaceWith('<i class="fa fa-caret-down fa-2x filter_box_toggle"></i>');
            });

            $('.filter_hidden').each(function(){
                $(this).slideDown();
            });
        }
        else{
            $('.filter_box_toggle').each(function(){
                $(this).replaceWith('<i class="fa fa-caret-up fa-2x filter_box_toggle"></i>');
            });

            $('.filter_hidden').each(function(){
                $(this).slideUp();
            });
        }
        setTimeout(function(){
            initBlogFilterEvents();
        }, 1000);
    });
}

function getBlogFiltersParams(){
    var _filters = "";
    var _filters_array = [];

    if($('#filter_search').val() != "")
        _filters_array.push('search=' + $('#filter_search').val());

    var _selected_categories = [];
    $('.filter_category').each(function(){
        if($(this).is(':checked')){
            _selected_categories.push($(this).val());
        }
    });
    if(_selected_categories.length > 0)
        _filters_array.push('cat_ids=' + _selected_categories.join(','));

    var _selected_years = [];
    $('.filter_year').each(function(){
        if($(this).is(':checked')){
            _selected_years.push($(this).val());
        }
    });
    if(_selected_years.length > 0)
        _filters_array.push('years=' + _selected_years.join(','));

    var _selected_months = [];
    $('.filter_month').each(function(){
        if($(this).is(':checked')){
            _selected_months.push($(this).val());
        }
    });
    if(_selected_months.length > 0)
        _filters_array.push('months=' + _selected_months.join(','));

    if(_filters_array.length > 0)
        _filters = "?" + _filters_array.join("&");
    return _filters;
}

var _featured_venues_conflict_prevention = false;
function initMultiSelectDropdown(_id, _label){
    $(_id).multiSelect({

        // Custom templates
        'containerHTML': '<div class="multi-select-container">',
        'menuHTML': '<div class="multi-select-menu">',
        'buttonHTML': '<span class="multi-select-button">',
        'menuItemsHTML': '<div class="multi-select-menuitems">',
        'menuItemHTML': '<label class="multi-select-menuitem">',
        'presetsHTML': '<div class="multi-select-presets">',

        // sets some HTML (eg: <div class="multi-select-modal">) to enable the modal overlay.
        'modalHTML': undefined,

        // Active CSS class
        'activeClass': 'multi-select-container--open',

        // Text to show when no option is selected
        'noneText': _label,

        // Text to show when all options are selected
        'allText': undefined,

        // an array of preset option groups
        // presets: [{
        //   name: 'All categories',
        //   all: true // select all
        // },{
        //   name: 'My categories',
        //   options: ['a', 'c']
        // }]
        'presets': undefined,

        // CSS class added to the container, when the menu is about to extend beyond the right edge of the position<a href="https://www.jqueryscript.net/menu/">Menu</a>Within element
        'positionedMenuClass': 'multi-select-container--positioned',

        // If you provide a jQuery object here, the plugin will add a class (see positionedMenuClass option) to the container when the right edge of the dropdown menu is about to extend outside the specified element, giving you the opportunity to use CSS to prevent the menu extending, for example, by allowing the option labels to wrap onto multiple lines.
        'positionMenuWithin': undefined,

        // The plugin will attempt to keep this distance, in pixels, clear between the bottom of the menu and the bottom of the viewport, by setting a fixed height style if the menu would otherwise approach this distance from the bottom edge of the viewport.
        'viewportBottomGutter': 20,

        // minimal height
        'menuMinHeight': 200

      });
}

function checkMobileHeights(){
    let myResizeCallback = function(){
        $('.mobile_check_height').each((k, v) => {
            let card = $(v).find('.card-wrapper-prestige');
            let H = $(card).outerHeight();
            let top = parseInt($(card).css('top'));
            let tot = H + top;
            $(v).height(tot);
        });
        reveal();
    };
    if(window.innerWidth < MOBILE_WIDTH_TRESHOLD) {
        setTimeout(myResizeCallback, 2000);
    }else{
        document.querySelectorAll('.mobile_check_height').forEach((v) => {
            v.style.removeProperty('height');
        });
    }
}

$(window).resize(function() {
    if(!$('body').hasClass('prestige')) {
        checkTop();
    }

//    fixGalleryTabs();
    if($('.vimeo').length > 0){
        checkVimeo();
    }
    checkMobileHeights();
});

function checkVimeo(){
    var ratio = $('.vimeo').parent().data('ratio');
    var wrapper = $('.vimeo').parent().parent();
    var W = $(wrapper).width();
    var estH = Math.round(W * (1/ratio));
    $(wrapper).height(estH);
}

function fixGalleryTabs(){
    $('.gallery-block .slick-dots').children().gt(4).each(function(k,v){
        $(v).remove();
    });
}

function checkTop(){
    var H = Math.floor($('header.page-head').outerHeight() - 1);
    $('.flexible-content-wrap-premium').css('paddingTop', H+'px');

    var W = $(window).width();
    var calc;
    if(W <= 750){
        calc = 'calc(50vh - '+H+'px)';
    }else{
        calc = 'calc(100vh - '+H+'px)';
    }
    $('.hero-block-wrapper img').css('height', calc);
    $('.hero-block-wrapper .videowrapper').css('height', calc);
    $('.hero-block-wrapper .videoplayer').css('height', calc);
    $('.hero-block-wrapper .overlay-wrapper').css('height', calc);

}

function convertUKDateStringToUSDateString(date){

    var dateParts = date.split("/");

    var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);

    return dateObject.toString();
}

function showMenu() {
    $('.menu-overlay').addClass('active');
    $('.menu-btn-open').addClass('hide');
    $('.menu-btn-close').addClass('active');

    // setTimeout(function(){
    //     $('html').addClass('modal-open');
    //     $('body').addClass('modal-open');
    //     $('.page-modal').addClass('active');
    // }, 400);
}
function hideMenu() {
    $('.menu-overlay').removeClass('active');
    $('.menu-btn-open').removeClass('hide');
    $('.menu-btn-close').removeClass('active');

    // setTimeout(function(){
    //     $('html').removeClass('modal-open');
    //     $('body').removeClass('modal-open');
    //     $('.page-modal').removeClass('active');
    // }, 400);

    if(window.innerWidth < MENU_MOBILE_WIDTH_TRESHOLD)
    {
        $('.menu-item-level-1').each(function(){
            $(this).removeClass('hide-menu-item');
            $(this).removeClass('mobile_active');
        });
        $('#column-right-content').removeClass('hide-menu-item');
    }
}

function scrollNext(el, _parent_class){
    let curRef = $(el).data('ref');
    if(typeof curRef === 'undefined'){
        let dest = $(el).closest(_parent_class).next();
        let curID = $(dest).attr('id');
        if(typeof curID === 'undefined'){
            dest = $(el).next(_parent_class).next();
            curID = $(dest).attr('id');
        }
        if(typeof curID === 'undefined'){
            dest = $(_parent_class).next();
            curID = $(dest).attr('id');
        }
        if(typeof curID === 'undefined'){
            let newId = "id-"+Math.floor(Math.random() * 999);
            $(dest).attr('id', newId);
            curRef = '#'+newId;
            $(el).data('ref', curRef);
        }
        else{
            curRef = '#'+curID;
            $(el).data('ref', curRef);
        }
    }
    $('html, body').animate({
        scrollTop: $(curRef).offset().top - 89
    }, 800, function(){
        // Add hash (#) to URL when done scrolling (default click behavior)
        // window.location.hash = curRef;
    });
}

function reveal() {
    var reveals = document.querySelectorAll(".reveal");
    for (var i = 0; i < reveals.length; i++) {
        var windowHeight = window.innerHeight;
        var elementTop = reveals[i].getBoundingClientRect().top;
        var elementVisible = 50;
        if (elementTop < windowHeight - elementVisible) {
            reveals[i].classList.add("active");
        } else {
            reveals[i].classList.remove("active");
        }
    }

    reveals = document.querySelectorAll(".reveal-no-fade");
    for (var i = 0; i < reveals.length; i++) {
        var windowHeight = window.innerHeight;
        var elementTop = reveals[i].getBoundingClientRect().top;
        var elementVisible = 50;
        if (elementTop < windowHeight - elementVisible) {
            reveals[i].classList.add("active");
        } else {
            reveals[i].classList.remove("active");
        }
    }
}